import { useMemo } from 'react';

import type { HomeTask } from './tasks';
import useMyTasks from '../../hooks/useMyTasks';
import type { Kitchen, Task } from '../../libs';

export type UseHomeTasksResult = { tasks: HomeTask[]; loading: boolean; error: boolean; reload: () => void };

export const fromTask = ({ id, kind, title, startsAt, endsAt, doneAt, productionPlan, videoReview }: Task): HomeTask => ({
  id,
  kind,
  title,
  startsAt,
  ...(endsAt ? { endsAt } : {}),
  ...(doneAt ? { doneAt } : {}),
  ...(productionPlan
    ? {
        productionPlan: {
          type: productionPlan.type,
          locationId: productionPlan.locationId ?? undefined,
          itemType: productionPlan.itemType ?? undefined,
          itemId: productionPlan.itemId ?? undefined,
          itemName: productionPlan.itemName ?? undefined,
          quantity: productionPlan.quantity ?? undefined,
          unit: productionPlan.unit ?? undefined,
          readyBy: productionPlan.readyBy ?? undefined,
          rationale: productionPlan.rationale
        }
      }
    : {}),
  ...(videoReview
    ? {
        videoReview: {
          jobId: videoReview.jobId,
          camera: videoReview.camera,
          room: videoReview.room ?? undefined,
          peopleCount: videoReview.peopleCount,
          newAnswerFromYourNotes: videoReview.newAnswerFromYourNotes
        }
      }
    : {})
});

const useHomeTasks = (kitchen: Kitchen): UseHomeTasksResult => {
  const { tasks, loading, error, reload } = useMyTasks(kitchen);
  return { tasks: useMemo(() => tasks.map(fromTask), [tasks]), loading, error, reload };
};

export default useHomeTasks;
